module.exports = __webpack_public_path__ + "img/GH-kyujin-webdesign003.05f1ed72.webp";